<script lang="ts">
  import { errorTracker, postWithJwt, serverlessRoutes, translate } from "lib";
  import { dialogData, showAlert } from "stores";
  import { ButtonComponent, TextareaField } from "ui";

  let data: any;
  let isLoading = false;
  let disabled = false;

  const form = {
    dateOfDispatch: { value: "", error: "" },
    title: { value: "", error: "" },
    message: { value: "", error: "" },
    email: { value: false, error: "" },
    sms: { value: false, error: "" },
    inApp: { value: false, error: "" },
    sendNow: { value: false, error: "" },
  };

  const getAction = (): number => {
    // action:

    // samo email:	0
    // samo sms:	1
    // samo in-app:	2
    // email + sms:	3
    // email + in-app:	4
    // sms + in-app:	5

    // email_many
    // sms_many
    // message_many
    const { email, sms, inApp } = form;

    if (email.value && !sms.value && !inApp.value) {
      return 0;
    } else if (!email.value && sms.value && !inApp.value) {
      return 1;
    } else if (!email.value && !sms.value && inApp.value) {
      return 2;
    } else if (email.value && sms.value && !inApp.value) {
      return 3;
    } else if (email.value && !sms.value && inApp.value) {
      return 4;
    } else {
      return 5;
    }
  };

  const onInput = (field: keyof typeof form): void => {};

  const onSubmit = async (): Promise<void> => {
    isLoading = true;

    if (data.ids) {
      const url = `${serverlessRoutes.MESSAGE}/queue`;
      const postData = {
        clientIds: data.ids,
        payload: form.message.value,
      };

      try {
        const res = await postWithJwt(url, postData);

        if (res.data.message === "Success.") {
          $showAlert.color = "black";
          $showAlert.message = translate("MESSAGES_SENT");

          $dialogData.type = "";
          $dialogData.data = {};
        }
      } catch (error) {
        isLoading = false;
        errorTracker.captureError(error, 'error', {
          context: "CreateAutoMessage.onSubmit",
          metadata: {
            clientIds: data.ids,
            messageLength: form.message.value.length
          }
        });
      }
    }
  };

  export { data };
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-center font-semibold">{translate("SEND_MESSAGE_U")}</div>

  <form on:submit|preventDefault={onSubmit}>
    <!-- {#if !form.sendNow.value}
      <DatePicker  bind:date="{form.dateOfDispatch.value}"/>
    {/if}

    {#if form.email.value}
      <Label for="title">{translate("TITLE")}:</Label>
      <Input
        id="title"
        placeholder="{translate("TITLE")}"
        bind:value="{form.title.value}"
        on:input="{() => onInput("title")}"/>
      <Helper color="red">
        {#if form.title.error}
          {form.title.error}
        {:else}
          ㅤ
        {/if}
      </Helper>
    {/if} -->

    <TextareaField
      label={translate("MESSAGE")}
      error={form.message.error}
      bind:value={form.message.value}
      on:input={() => onInput("message")}
    />

    <!-- <Label>{translate("DISPATCH_METHOD")}:</Label>
    <CheckboxComponent bind:checked="{form.email.value}">Email</CheckboxComponent>
    <CheckboxComponent bind:checked="{form.sms.value}">SMS</CheckboxComponent>
    <CheckboxComponent bind:checked="{form.inApp.value}">{translate("IN_APP")}</CheckboxComponent>

    {#if data.ids && data.ids.length > 1}
      <CheckboxComponent bind:checked="{form.sendNow.value}">{translate("SEND_NOW")}</CheckboxComponent>
    {/if} -->

    <div class="flex justify-center">
      <ButtonComponent
        type="submit"
        {disabled}
        {isLoading}
      >
        {translate("SEND")}
      </ButtonComponent>
    </div>
  </form>
</div>
